import React, { useState, useEffect } from 'react'
import '../../_css/AddSchool.css'
import { addSchool, editSchool } from '../../requests'
import { notifySuccess, notifyError } from '../../utils/helper'
import { useDispatch } from 'react-redux'
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer'

const AddSchool = ({ onClose , type='add', data=null, onRefresh}) => {
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    schoolId: '',
    schoolName: '',
    schoolCode: 'TMAI_',
    schoolLocation: ''
  })

  useEffect(() => {
    if(type === 'edit' && data) {
      setFormData({
        schoolName: data.school_name,
        schoolCode: data.school_code,
        schoolLocation: data.location
      })
    }
  }, [type, data])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSchoolCodeChange = (e) => {
    let value = e.target.value
    const prefix = 'TMAI_'
    
    // Always ensure prefix is present
    if (!value.startsWith(prefix)) {
      // If user deleted the prefix, restore it
      if (value.length < prefix.length) {
        value = prefix
      } else {
        // If user typed something without prefix, add it
        value = prefix + value.replace(/^TMAI_/, '')
      }
    }
    
    setFormData(prev => ({
      ...prev,
      schoolCode: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    // Validation
    if (!formData.schoolName.trim()) {
      notifyError('Please enter a school name')
      return
    }
    
    if (!formData.schoolCode.trim() || formData.schoolCode === 'TMAI_' || formData.schoolCode.length <= 5) {
      notifyError('Please enter a school code after TMAI_')
      return
    }

    dispatch(startLoader())

    try {
      let response = null;
      if(type === 'add') {
        response = await addSchool({
            school_name: formData.schoolName,
            school_code: formData.schoolCode.trim(),
            school_location: formData.schoolLocation || 'Other'
          })

      } else {
        response = await editSchool({
          school_id: data.id,
          school_name: formData.schoolName,
          school_code: formData.schoolCode.trim(),
          school_location: formData.schoolLocation || 'Other'
        })
      }

    

      if (response.status === 200) {
        notifySuccess(response.data.message || 'School added successfully')
        onClose()
        // Reset form
        setFormData({
          schoolName: '',
          schoolCode: 'TMAI_',
          schoolLocation: ''
        })
        onRefresh()
      }
    } catch (error) {
      console.error('Error adding school:', error)
      notifyError(error?.response?.data?.error || 'Something went wrong')
    } finally {
      dispatch(stopLoader())
    }
  }

  const handleClose = () => {
    onClose()
    // Reset form
    setFormData({
      schoolName: '',
      schoolCode: 'TMAI_',
      schoolLocation: ''
    })
  }

  return (
    <div className="add-school-modal-overlay" onClick={handleClose}>
      <div className="add-school-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="add-school-modal-head">
          <div className="add-school-modal-head-text">{type === 'add' ? 'Add School' : 'Edit School'}</div>
          <img
            style={{ cursor: "pointer" }}
            onClick={handleClose}
            src="/close.svg"
            alt="Close"
          />
        </div>
        
        <form className="add-school-modal-body" onSubmit={handleSubmit}>
          <div className="add-school-input-area">
            <label className="add-school-label">School Name *</label>
            <input
              type="text"
              name="schoolName"
              value={formData.schoolName}
              onChange={handleChange}
              className="add-school-input"
              placeholder="Enter school name"
             
            />
          </div>

          <div className="add-school-input-area">
            <label className="add-school-label">School Code *</label>
            <input
              type="text"
              name="schoolCode"
              value={formData.schoolCode}
              onChange={handleSchoolCodeChange}
              className="add-school-input"
              placeholder="TMAI_"
              
            />
          </div>

          <div className="add-school-input-area">
            <label className="add-school-label">School Location</label>
            <input
              type="text"
              name="schoolLocation"
              value={formData.schoolLocation}
              onChange={handleChange}
              className="add-school-input"
              placeholder="Enter school location"
            />
          </div>

          <div className="add-school-modal-footer">
            <button 
              type="button"
              className="add-school-cancel-btn" 
              onClick={handleClose}
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="add-school-submit-btn"
            >
              {type === 'add' ? 'Submit' : 'Update'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddSchool
